import { Button } from '@mui/material';
import { ROUTE, THEME } from 'constant';
import React, { useState } from 'react';
import Shared from 'screens/shared';
import { form, formField } from 'types';
import {
  copyToClipboard, enumToArray, isEmptyObject, varToText,
} from 'utils';
import { getConfig } from 'utils/config';

export const Configuration = () => {
  const [url, setUrl] = useState('');
  const config = getConfig();

  const fields = [
    formField.dropdown({ name: 'theme', title: 'Brand / Theme', options: enumToArray(THEME) }),
    formField.text({ name: 'apiBaseUrl', title: 'API Base URL' }),
    formField.text({ name: 'apiKeyManagerUrl', title: 'API Key Manager URL' }),
    formField.text({ name: 'apiBillingUrl', title: 'API Billing URL' }),
    formField.text({ name: 'apiResellerUrl', title: 'API Reseller URL' }),
    formField.text({ name: 'apiAuthUrl', title: 'API Auth URL' }),
    formField.text({ name: 'apiTelemetryUrl', title: 'API Telemetry URL' }),
    formField.text({ name: 'apiMonitoringUrl', title: 'API Monitoring URL' }),
    formField.text({ name: 'apiAutoScalingUrl', title: 'API Auto Scaling URL' }),
    formField.text({ name: 'apiCertificateManagerUrl', title: 'API Certificate Manager URL' }),
    formField.text({ name: 'apiDBaaSUrl', title: 'API DBaaS URL' }),
    formField.text({ name: 'apiAdServerUrl', title: 'API Ad Server URL' }),
    formField.object({
      name: 'features',
      title: 'Feature Flags',
      fields: Object.keys(config?.features || {}).map((key) => formField.switch({ name: key, title: varToText(key) })),
    }),
    formField.object({
      name: 'loginScreen',
      title: 'Login Screen',
      fields: Object.keys(config?.loginScreen || {}).map((key) => formField.switch({ name: key, title: varToText(key) })),
      visible: !isEmptyObject(config?.loginScreen),
    }),
  ];

  const formProps = form({
    title: <div className="-m-b-20">Customize Configuration</div>,
    fields,
    isCancel: false,
    onSubmit: (newConfig) => {
      Object.keys(newConfig).forEach((key) => {
        if (JSON.stringify(config[key]) === JSON.stringify(newConfig[key])) delete newConfig[key];
      });
      setUrl(`${window.location.origin}${process.env.PUBLIC_URL}${ROUTE.NON_SECURE.LOGIN.path}?config=${JSON.stringify(newConfig)}`);
    },
    submitTitle: 'Generate Customized URL',
    fieldsValues: config,
    onlyFieldsValue: true,
  });

  return (
    <div className="customize-config">
      {url ? (
        <div className="result">
          <p>Generated customized URL</p>
          <div className="url">
            <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
          </div>
          <div className="m-t-10">
            <Button onClick={() => copyToClipboard(url)} color="primary">Copy</Button>
            <Button onClick={() => setUrl('')} color="primary" variant="contained">Generate Again</Button>
          </div>
        </div>
      ) : (
        <Shared.forms.Form {...formProps} />
      )}
    </div>
  );
};
